import { ReactChild, ReactElement, ReactFragment, ReactPortal } from 'react';
import Modal from '@components/Modal';
import { getLabelFallback } from '@utils/utils';

type PrescriptionModalProps = {
    close: () => void;
    prescription: any;
}

const PrescriptionModal = (props : PrescriptionModalProps) : ReactElement => {

    const {
        close,
        prescription
    } = props;

    return(
        <div className="prescription-modal">
            <Modal close={close}>
                <div className="prescription-modal-content">
                    <h2 className="prescription-modal-title">{ getLabelFallback('PRESCRIPTION_MODAL_TITLE') }</h2>
                    <div className="prescription-modal-grid">
                        <div className="prescription-modal-grid-column bigger">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header-darker">{ getLabelFallback('PRESCRIPTION_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <div className="prescription-modal-grid-subcolumn bigger">
                                    <span className="prescription-modal-grid-column-cell stretched">{ getLabelFallback('DISTANCE_MODAL_LABEL') }</span>
                                </div>
                                <div className="prescription-modal-grid-subcolumn">
                                    <div className="prescription-modal-grid-row">
                                        <span className="prescription-modal-grid-column-cell">{ getLabelFallback('OD_MODAL_LABEL') }</span>
                                    </div>
                                    <div className="prescription-modal-grid-row">
                                        <span className="prescription-modal-grid-column-cell">{ getLabelFallback('OS_MODAL_LABEL') }</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="prescription-modal-grid-column">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header">{ getLabelFallback('PWR_SHP_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.rightSphere ? prescription.rightSphere : '0'}</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.leftSphere ? prescription.leftSphere : '0'}</span>
                            </div>
                        </div>
                        <div className="prescription-modal-grid-column">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header">{ getLabelFallback('CYL_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.rightCyl ? prescription.rightCyl : '0'}</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.leftCyl ? prescription.leftCyl : '0'}</span>
                            </div>
                        </div>
                        <div className="prescription-modal-grid-column">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header">{ getLabelFallback('AXIS_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.rightAxis ? prescription.rightAxis : '0'}</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.leftAxis ? prescription.leftAxis : '0'}</span>
                            </div>
                        </div>
                        <div className="prescription-modal-grid-column">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header">{ getLabelFallback('ADD_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.rightAdd ? prescription.rightAdd : '0'}</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.leftAdd ? prescription.leftAdd : '0'}</span>
                            </div>
                        </div>
                    </div>
                    {prismDetailsTable(prescription)}
                </div>
            </Modal>
        </div>
    )
}

//show prism values table only if prismEnable is "true"
function prismDetailsTable(prescription) {
    if (prescription.prismEnable == "true") {
      return <div className="prescription-modal-grid">
                        <div className="prescription-modal-grid-column bigger">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header-darker">{ getLabelFallback('PRESCRIPTION_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <div className="prescription-modal-grid-subcolumn bigger">
                                    <span className="prescription-modal-grid-column-cell stretched">{ getLabelFallback('PRISM_MODAL_LABEL') }</span>
                                </div>
                                <div className="prescription-modal-grid-subcolumn">
                                    <div className="prescription-modal-grid-row">
                                        <span className="prescription-modal-grid-column-cell">{ getLabelFallback('OD_MODAL_LABEL') }</span>
                                    </div>
                                    <div className="prescription-modal-grid-row">
                                        <span className="prescription-modal-grid-column-cell">{ getLabelFallback('OS_MODAL_LABEL') }</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="prescription-modal-grid-column">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header">{ getLabelFallback('VERTICAL_PRISM_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.odVPrism ? prescription.odVPrism : '0'}</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.osVPrism ? prescription.osVPrism : '0'}</span>
                            </div>
                        </div>
                        <div className="prescription-modal-grid-column">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header">{ getLabelFallback('BASE_DIR_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.odVPrismBaseDir ? prescription.odVPrismBaseDir : '-'}</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.osVPrismBaseDir ? prescription.osVPrismBaseDir : '-'}</span>
                            </div>
                        </div>
                        <div className="prescription-modal-grid-column">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header">{ getLabelFallback('HORIZONTAL_PRISM_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.odHPrism ? prescription.odHPrism : '0'}</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.osHPrism ? prescription.osHPrism : '0'}</span>
                            </div>
                        </div>
                        <div className="prescription-modal-grid-column">
                            <div className="prescription-modal-grid-row labels">
                                <span className="prescription-modal-grid-column-header">{ getLabelFallback('BASE_DIR_MODAL_LABEL') }</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.odHPrismBaseDir ? prescription.odHPrismBaseDir : '-'}</span>
                            </div>
                            <div className="prescription-modal-grid-row">
                                <span className="prescription-modal-grid-column-cell">{!!prescription.osHPrismBaseDir ? prescription.osHPrismBaseDir : '-'}</span>
                            </div>
                        </div>
                    </div>;
    }
  }
  

export default PrescriptionModal;